import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useGlobal } from "../../context/GlobalContext";
import { useAuraVoice } from "../../hooks/useAuraVoice";
import "./ChallengeDescription.css";

import Card from "../../components/Card/Card";
import Stars from "../../assets/stars.svg";

const ChallengeDescription = () => {
  const { state, dispatch } = useGlobal(); // Removido o 'state' pois não é mais usado aqui
  useAuraVoice("Hmm, entendi... Agora me diz uma coisa, quais são suas principais dores nesse contexto?", "question");

  // Pega as opções do estado global, se não houver, usa um array vazio
  const cardOptions = state.pains_options || [];

  const [selectedOptions, setSelectedOptions] = useState([]);
  const navigate = useNavigate();

  const handleCardClick = (option) => {
    const isSelected = selectedOptions.includes(option);
    if (isSelected) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else if (selectedOptions.length < 3) {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const handleContinueClick = () => {
    dispatch({
      type: "UPDATE_STATE",
      payload: { selected_pains: selectedOptions },
    });
    navigate("/expected-result");
  };

  return (
    <motion.div
              className="cd-container"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
      <img
        src={Stars}
        alt="Estrelas no fundo"
        className="cd-stars-background"
      />

      <header className="cd-header">
        <h1>Quais são suas principais dores?</h1>
        <p>Escolha 3 dores que mais se relacionam com o seu desafio</p>
      </header>

      <main className="cd-grid">
        {cardOptions.map((optionText) => (
          <Card
            key={optionText}
            text={optionText}
            isSelected={selectedOptions.includes(optionText)}
            onClick={() => handleCardClick(optionText)}
          />
        ))}
      </main>

      <div className="continue-button-container">
        {selectedOptions.length === 3 && (
          <button className="new-continue-button" onClick={handleContinueClick}>
            Confirmar
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default ChallengeDescription;